import { faGift } from "@awesome.me/kit-f3e20eab48/icons/classic/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState, type CSSProperties } from "react";
import { useTranslation } from "react-i18next";
import { formatMinorUnits } from "../../../../../logic/helpers/currencyAmount";
import type { RewardCollectionItemData } from "../../../../../logic/helpers/rewardCollection";
import rays from "../../../../../assets/static/images/reward-collection/rays.png";
import glow from "../../../../../assets/static/images/reward-collection/glow.png";
import "./RewardCollectionItem.scss";

interface RewardCollectionItemProps {
    reward: RewardCollectionItemData;
    lightFilterId: string;
}

export function RewardCollectionItem({
    reward,
    lightFilterId,
}: RewardCollectionItemProps) {
    const { i18n } = useTranslation();
    const [failedImageUrl, setFailedImageUrl] = useState<string>();
    const amount = formatMinorUnits(
        reward.amount,
        reward.decimalScale,
        i18n.resolvedLanguage ?? i18n.language,
    );
    return (
        <li
            className="reward-collection-item"
            aria-label={`${amount} ${reward.label}`}
        >
            <div className="reward-collection-item__light" aria-hidden="true">
                <img
                    className="reward-collection-item__rays"
                    src={rays}
                    style={{ filter: `url(#${lightFilterId})` }}
                    alt=""
                    draggable={false}
                />
                <img
                    className="reward-collection-item__glow"
                    src={glow}
                    alt=""
                    draggable={false}
                />
            </div>
            <div className="reward-collection-item__content" aria-hidden="true">
                {reward.imageUrl && failedImageUrl !== reward.imageUrl ? (
                    <img
                        className="reward-collection-item__image"
                        src={reward.imageUrl}
                        alt=""
                        draggable={false}
                        onError={() => setFailedImageUrl(reward.imageUrl)}
                    />
                ) : (
                    <FontAwesomeIcon
                        className="reward-collection-item__fallback"
                        icon={faGift}
                    />
                )}
                <span
                    className="reward-collection-item__amount"
                    dir="ltr"
                    data-length={amount.length > 9 ? "long" : "normal"}
                    style={
                        {
                            "--reward-amount-size": Math.min(
                                120,
                                360 / amount.length,
                            ),
                        } as CSSProperties
                    }
                >
                    {amount}
                </span>
            </div>
        </li>
    );
}
